import * as React from 'react';
import { lighten } from 'polished';
import styled, { StyledFunction } from 'styled-components';
import * as ChatBubbleIcon from 'react-icons/lib/io/chatbubble';
import { ProactiveActionPayload } from '../../typedefs/actions';
import { ProactiveSettings } from '../../typedefs/store';
import { proactiveAnimation, styledWithProps, withMedia, WithMediaProps } from '../../util/styles';

interface Props extends WithMediaProps {
    settings: ProactiveSettings;
    proactiveItem?: ProactiveActionPayload;
    onClick: () => void;
    onClose: () => void;
}

class ProactiveBubble extends React.Component<Props, {}> {
    render() {
        if (!this.props.proactiveItem) {
            return null;
        }

        const { settings } = this.props;
        return (
            <Positioner settings={settings} isMobile={this.props.isMobile} className="conversations-proactive-container">
                <Bubble className="conversations-proactive" settings={settings}>
                    <BubbleClose settings={settings} onClick={this.props.onClose} />
                    <BubbleLink
                        settings={settings}
                        onClick={this.props.onClick}>
                        {this.props.proactiveItem.displayMessage}
                    </BubbleLink>
                </Bubble>
            </Positioner>
        );
    }
}

const getPositionFromCta = (settings: ProactiveSettings, isMobile: boolean) => {
    if (isMobile) {
        return `right: 20px; bottom: calc(${settings.ctaBottomMargin} + 70px);`;
    }

    const xAlign = settings.ctaPosition.includes('right') ? 'right: 20px;' : 'left: 20px;';
    if (settings.ctaType === 'circle') {
        return `${xAlign} bottom: 120px;`;
    } else if (settings.ctaType === 'circle with tail') {
        return `${xAlign} bottom: 140px;`;
    } else if (settings.ctaType === 'tab') {
        return `${xAlign} bottom: ${settings.ctaPosition.includes('bottom') ? 60 : 20}px;`;
    } else {
        return ``;
    }
};

const div = styledWithProps<{ settings: ProactiveSettings, isMobile: boolean }>(styled.div);
const Positioner = div`
    position: fixed;
    bottom: 125px;
    ${props => getPositionFromCta(props.settings, props.isMobile)}
    z-index: ${props => props.settings.zIndex};
    ${proactiveAnimation}
`;

const Bubble = styledWithProps<{ settings: ProactiveSettings }>(styled.div)`
    position: relative;
    background-color: ${props => props.settings.ctaBackgroundColor};
    color: ${props => props.settings.ctaForegroundColor};
    border-radius: .4em;
    padding: 18px;
    max-width: 195px;
`;

const BubbleClose = styledWithProps<{ settings: ProactiveSettings } & React.HTMLProps<HTMLInputElement>>(styled.div)`
    color: ${props => props.settings.ctaForegroundColor};
    text-decoration: none;
    cursor: pointer;
    width: 18px;
    height: 18px;
    position: absolute;
    top: 4px;
    right: 3px;
    font-size: 0.8em;
    text-align: center;

    &::after {
        content: 'X';
    }
`;

const BubbleLink = styledWithProps<{ settings: ProactiveSettings } & React.HTMLProps<HTMLInputElement>>(styled.div)`
    color: ${props => props.settings.ctaForegroundColor};
    text-decoration: none;
    cursor: pointer;

    &:hover {
        color: ${props => lighten(0.2, props.settings.ctaForegroundColor)};
    }
`;

export default withMedia(ProactiveBubble);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Proactive/ProactiveBubble.tsx